import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ConversationMessagesResponse,
  CreateMessageResponse,
  Message,
} from '@repo/shared/src/services/messaging-service/messaging-service.types';
import { Observable, Subject } from 'rxjs';
import { BACK_API_URL } from '../../app.tokens';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private isMessagesNoReply: Subject<boolean> = new Subject<boolean>();

  constructor(@Inject(BACK_API_URL) private readonly API_URL: string, private readonly http: HttpClient) {}

  getMessageList(conversationId: string): Observable<ConversationMessagesResponse> {
    return this.http.get<ConversationMessagesResponse>(`${this.API_URL}/conversations/${conversationId}/messages`);
  }

  postMessage(message: Message, conversationId: string): Observable<CreateMessageResponse> {
    return this.http.post<CreateMessageResponse>(`${this.API_URL}/conversations/${conversationId}/messages`, message);
  }

  patchMessage(message: Message, messageId: string): Observable<void> {
    return this.http.patch<void>(`${this.API_URL}/messages/${messageId}`, message);
  }

  deleteMessage(messageId: string): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/messages/${messageId}`);
  }

  getIsMessagesNoReply(): Observable<boolean> {
    return this.isMessagesNoReply.asObservable();
  }

  setIsMessagesNoReply(isMessagesNoReply: boolean): void {
    this.isMessagesNoReply.next(isMessagesNoReply);
  }
}
